import { ReactNode } from 'react';
import { InputLabel } from './InputLabel';

/**
 * @deprecated Use 'TimeInput' from '@client/new/components/common/inputs/TimeInput'
 */
export const TimeInput = ({
  label,
  value,
  onChange,
}: {
  label?: ReactNode;
  value: string;
  onChange: (val: string) => any;
}) => {
  return (
    <div>
      <InputLabel {...{ label }} />
      <input
        className="relative border-2 border-[#DAE1ED] bg-[#FAFCFD] px-4 pt-[8px] pb-[8px] rounded-lg focus-within:border-primary transition-colors"
        type="time"
        value={value}
        onChange={(val) => onChange(val.target.value)}
      />
    </div>
  );
};
